import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  url: string;
  accessToken: any;
  token_type: any;
  token: string;
  constructor(private apiService: ApiService) {

  }

  getMeetingRooms(): Observable<any> {
    this.url = APIs.getReportMeetingRooms;
    const paramObj = {
    };
    return this.apiService.get(this.url, paramObj).pipe(map(response => {
      return response;
    }));
  };

  getAccessPoints(): Observable<any> {
    this.url = APIs.getAccessPoints;
    const paramObj = {
      locationId: localStorage.getItem('locationId'),
    };
    return this.apiService.get(this.url, paramObj).pipe(map(response => {
      return response;
    }));
  };

  getDepartments(): Observable<any> {
    this.url = APIs.getDepartments;
    const paramObj = {
    };
    return this.apiService.get(this.url, paramObj).pipe(map(response => {
      return response;
    }));
  };

  getCheckInReports(AccessPointId, FromDate, ToDate,CreatedBy): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getCheckins;
    const paramObj = {
      accessPointId: AccessPointId,
      fromDate: FromDate,
      toDate: ToDate,
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      createdBy:CreatedBy,
      locationId: locationId
    };
    return this.apiService.post(this.url, paramObj, '').pipe(map(response => {
      return response;
    }));
  };

  getCreditReports(FromDate, ToDate,createdById,CreatedBy): Observable<any> {
    this.url = APIs.getCreditReports;
    const paramObj = {
      fromDate: FromDate,
      toDate: ToDate,
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      bookedBy:createdById,
      createdBy:CreatedBy
    };
    return this.apiService.post(this.url, paramObj, '').pipe(map(response => {
      return response;
    }));
  };

  getEmployeeReports(DepartmentId, FromDate, ToDate): Observable<any> {
    this.url = APIs.getEmployees;
    const paramObj = {
      departmentId: DepartmentId,
      fromDate: FromDate,
      toDate: ToDate,
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId)
    };
    return this.apiService.post(this.url, paramObj, '').pipe(map(response => {
      return response;
    }));
  };

  getMeetingReports(meetingRoomId, FromDate, ToDate,BooKedBy,CreatedBy): Observable<any> {
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getMeetings;
    const paramObj = {
      meetingRoomId: meetingRoomId,
      fromDate: FromDate,
      toDate: ToDate,      
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      bookedBy:BooKedBy,
      createdBy:CreatedBy,
      locationId: locationId
    };
    return this.apiService.post(this.url, paramObj, '').pipe(map(response => {
      return response;
    }));
  };
}
